import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ReadNews = () => {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const API = "https://gp-chandoli-khurd.com/backend/api";

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const res = await fetch(`${API}/news/get_news.php`);
      const data = await res.json();

      if (data.status === "success") {
        setNewsList(data.news);
      } else {
        setError(data.message || "Failed to fetch news");
      }
    } catch (err) {
      setError("Error: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteNews = async (id) => {
    if (!window.confirm("Are you sure you want to delete this news?")) return;

    try {
      const res = await fetch(`${API}/news/delete_news.php?id=${id}`);
      const data = await res.json();

      if (data.status === "success") {
        alert("News deleted successfully");
        fetchNews();
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (loading) return <p className="p-5">Loading news...</p>;
  if (error) return <p className="text-red-600 p-5">{error}</p>;

  return (
    <div className="max-w-7xl mx-auto p-6">

      <h2 className="text-2xl font-bold mb-6">News List</h2>

      {newsList.length === 0 && <p>No news found.</p>}

      <div className="overflow-x-auto">

        <table className="w-full border border-gray-200">

          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 border">ID</th>
              <th className="p-3 border">Title</th>
              <th className="p-3 border">Content</th>
              <th className="p-3 border">Photo</th>
              <th className="p-3 border">PDF</th>
              <th className="p-3 border">Actions</th>
            </tr>
          </thead>

          <tbody>
            {newsList.map((news) => (
              <tr key={news.id} className="text-center">

                <td className="p-3 border">{news.id}</td>

                <td className="p-3 border font-semibold">
                  {news.title}
                </td>

                <td className="p-3 border">
                  {news.content.substring(0, 80)}...
                </td>

                <td className="p-3 border">
                  {news.photo && (
                    <img
                      src={`https://gp-chandoli-khurd.com/backend/api/news/${news.photo}`}
                      alt={news.title}
                      className="w-20 mx-auto rounded"
                    />
                  )}
                </td>

                <td className="p-3 border">
                  {news.pdf_file && (
                    <a
                      href={`https://gp-chandoli-khurd.com/backend/api/news/${news.pdf_file}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      View
                    </a>
                  )}
                </td>

                <td className="p-3 border space-x-2">

                  <Link
                    to={`/dashboard/news/update-news/${news.id}`}
                    className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                  >
                    Edit
                  </Link>

                  <button
                    onClick={() => deleteNews(news.id)}
                    className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                  >
                    Delete
                  </button>

                </td>

              </tr>
            ))}
          </tbody>

        </table>

      </div>

    </div>
  );
};

export default ReadNews;